export default class RevealEffect {
	constructor() {
		// Observer for reveal effect
		this.observerOptions = {
			// threshold: [0, 1]
		};
		this.init();
	}

	init() {
		const observerEffectFade = new IntersectionObserver((entries) => {
			entries.map((entry, index) => {
				if (entry.isIntersecting) {
					setTimeout(() => {
						entry.target.classList.add("is-in-view");
						observerEffectFade.unobserve(entry.target);
					}, 200 * index);
				}
			});
		}, this.observerOptions);

		document
			.querySelectorAll(".reveal-effect")
			.forEach((observable) => observerEffectFade.observe(observable));
	}
}
